// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReactCollapse--collapse{transition:height .4s}", "",{"version":3,"sources":["webpack://./src/components_sb/feedback/InlineError/InlineError.css"],"names":[],"mappings":"AACA,yBACE,qBACF","sourcesContent":["/* Animation duration for react-collapse */\n.ReactCollapse--collapse {\n  transition: height 400ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
